<h1 mat-dialog-title class="pt-2 text-center"> Ajout d'un matériel</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row m-0">
            <mat-form-field class="col">
                <mat-label>Type</mat-label>
                <mat-select placeholder="Type" [(ngModel)]="Model.Type">
                    @for (d of MaterielAdductionList; track d; let i = $index) {
                    <mat-option [value]="i">
                        {{ d }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Fabricant</mat-label>
                <input matInput [(ngModel)]="Model.Fabricant" placeholder="Fabricant" required>
            </mat-form-field>
        </div>

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Référence</mat-label>
                <input matInput [(ngModel)]="Model.Reference" placeholder="Référence" required>
            </mat-form-field>
        </div>

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Description</mat-label>
                <textarea matInput [(ngModel)]="Model.Description" placeholder="Description" required></textarea>
            </mat-form-field>
        </div>

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Référence Huile</mat-label>
                <textarea matInput [(ngModel)]="Model.MaterielCompresseur.ReferenceHuile" placeholder="Référence Huile" required></textarea>
            </mat-form-field>
        </div>

        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()" [disabled]="!canFinish()">
                Ajouter
            </button>
        </div>
    </div>
</div>